// extracted by mini-css-extract-plugin
module.exports = {"sectorWithSticky":"_02712f2b3b--sectorWithSticky--lvn_F","section--anchor":"_02712f2b3b--section--anchor--sOsYR","title":"_02712f2b3b--title--pGpM3"};